import { atom } from 'jotai';

export const streamUnreadCountAtom = atom<number>(0);
